"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
exports.newApiKeyMarkets = [constants_1.default.BE_LRE_PL_DIMENSIONS.brand, constants_1.default.BE_JAG_PL_DIMENSIONS.brand];
